import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Wrench, KeyRound } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * If maintenance_mode is enabled in admin settings, blocks public access
 * with a maintenance screen — except for authenticated admins (who can still
 * access /admin and /login) and the login page itself.
 */
export default function MaintenanceGate({ children }) {
  const [checking, setChecking] = useState(true);
  const [maintenance, setMaintenance] = useState(false);
  const [message, setMessage] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      axios.get(`${API}/settings/public`).catch(() => ({ data: {} })),
      axios.get(`${API}/auth/me`, { withCredentials: true }).catch(() => ({ data: null })),
    ]).then(([s, me]) => {
      if (cancelled) return;
      setMaintenance(Boolean(s.data?.maintenance_mode));
      setMessage(s.data?.maintenance_message || 'Le site est temporairement indisponible pour maintenance.');
      setIsAdmin(me.data?.role === 'admin');
      setChecking(false);
    });
    return () => { cancelled = true; };
  }, []);

  if (checking) return null;

  const path = window.location.pathname || '/';
  const isExempt = isAdmin || path.startsWith('/admin') || path === '/login' || path.startsWith('/auth/');

  if (maintenance && !isExempt) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] px-6"
        data-testid="maintenance-screen">
        <div className="max-w-lg w-full text-center">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#D87D4A]/10 mb-6">
            <Wrench className="text-[#D87D4A]" size={48} />
          </div>
          <h1 className="text-4xl font-bold text-[#2E332D] mb-4"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Site en maintenance
          </h1>
          <p className="text-[#5C665A] leading-relaxed mb-6">{message}</p>
          <a href="/login" data-testid="maintenance-admin-login"
            className="inline-flex items-center gap-2 text-sm font-bold text-[#4A6B48] hover:underline">
            <KeyRound size={14} /> Connexion administrateur
          </a>
          <p className="text-xs text-[#5C665A] mt-8">© CRESA ASBL</p>
        </div>
      </div>
    );
  }

  return children;
}
